export enum SupplierDashboardEnum {
    MODULE_ACCESS = 'View',
    FILTER_BY_VIEW = 'Filter_by_View',
    FILTER_BY_EDIT = 'Filter_by_Edit',
    SUPPLIER_DASHBOARD_GRID_VIEW = 'Supplier_Dashboard_Grid_View',
    SUPPLIER_DASHBOARD_GRID_EDIT = 'Supplier_Dashboard_Grid_Edit',
}
